import React from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import FcPublicPayment from './fcPublicPayment'

const PublicPayment: React.FC = () => {
  const stripePromise = loadStripe(
    // 'pk_test_51OzdEkP1vfmwjObRWZs9jeUgtjVr5yPKXnOEtrKZbJdd7boKLUA7KP6VVEmXkqJJegtrebeTm3z9plymQavS3ZwL009Vrh8Udc',
      'pk_live_51OzdEkP1vfmwjObRvRrgzAJK6t50avVcC79ukYvChcLYpCQPS6fJenImQi1dJgkZQYzFtmyu4TJ3Wjbqzq2MiGKu00syVqIEXn'

  )
  return (
    <div>
      <Elements stripe={stripePromise}>
        <FcPublicPayment />
      </Elements>
    </div>
  )
}
export default PublicPayment
